import { FunctionComponent } from 'react'
import Dialog from '@/components/_custom/Dialog/Dialog'
import { useTranslation } from 'react-i18next'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import styles from './confirmDeleteGroupLogo.module.scss'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { Check, Close } from '@mui/icons-material'
import { useMutation } from '@apollo/client'
import { DELETE_DAYCARE_GROUP_LOGO } from '@/modules/API/daycareGroup/daycareGroupHandler'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface ConfirmDeleteGroupLogoDialogProps {
    open: boolean
    handleClose: () => void
    groupId: number
    refetchGroups: () => void
}

const ConfirmDeleteGroupLogoDialog: FunctionComponent<ConfirmDeleteGroupLogoDialogProps> = ({
    open,
    handleClose,
    groupId,
    refetchGroups
}) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [deleteGroupLogo] = useMutation(DELETE_DAYCARE_GROUP_LOGO, {
        variables: {
            groupId: groupId
        },
        onCompleted: () => {
            showNotificationSuccess(t('logoDeleted'))

            refetchGroups()
            handleClose()
        },
        onError: () => {
            showNotificationError(t('logoDeleteError'))

            refetchGroups()
            handleClose()
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose} className={styles.Dialog}>
            <DialogHeader title={t('deleteLogo')} />
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>{t('deleteLogoMessage')}</p>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<Check />}
                        onClick={deleteGroupLogo}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ConfirmDeleteGroupLogoDialog
